<template>
<div
  class="cursor-pointer mt-2 limite-texto"
  :class="{ 'zipcode-white': smallIcon }"
  v-if="selectedZipcode"
  data-bs-toggle="modal"
  data-bs-target="#zipCode"
>
<img
  :src="smallIcon ? '/img/newsIcons/LOCK_BRANCO.webp' : '/img/newsIcons/LOCK_AZUL.webp'"
  alt=""
  :class="[smallIcon ? 'zipcode-known-small' : 'zipcode-known']"
/>
  {{ selectedZipcode?.logradouro }} - {{ selectedZipcode?.cep }}
</div>  
<div class="mt-2 selectedZipcode" v-if="!selectedZipcode">
  <div
    class="cursor-pointer"
    @click="showMini = true"
    :class="{ 'zipcode-white': smallIcon }"
  >
<img
  :src="smallIcon ? '/img/newsIcons/LOCK_BRANCO.webp' : '/img/newsIcons/LOCK_AZUL.webp'"
  alt=""
  :class="[smallIcon ? 'zipcode-unknown-small' : 'zipcode-unknown']"
/>
    Digite seu Endereço
  </div>
    <div class="card zipcard bg-white" v-if="showMini">
      <div class="card-body">
        <i class="fas fa-times float-end cursor-pointer" @click="closeMini()"></i>
        <h5 class="card-title">Confira o envio para o seu endereço</h5>
        <p class="card-text">
          Inclua seu CEP para verificar os custos e prazos de entrega precisos
          na busca.
        </p>
        <a
          href="#"
          class="btn btn-primary"
          data-bs-toggle="modal"
          data-bs-target="#zipCode"
          >Incluir CEP</a
        >
      </div>
    </div>
  </div>
  <!-- Modal -->
  <div
    class="modal fade"
    id="zipCode"
    tabindex="-1"
    aria-labelledby="zipCodeLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="zipCodeLabel">
            Selecione onde quer receber suas compras
            <br />
            <small class="text-muted"
              >Você poderá ver custos e prazos de entrega precisos em tudo que
              procurar.</small
            >
          </h4>
          <button
            type="button"
            class="btn-close"
            ref="Close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <label for="">Código de Endereçamento Postal</label>
          <div class="input-group mb-3">
            <input
              type="text"
              v-mask="'#####-###'"
              class="form-control py-2"
              v-model="zipcode"
              placeholder="Informe o CEP"
              aria-label="Informe o CEP"
              aria-describedby="button-addon2"
            />
            <button
              class="btn btn-primary"
              type="button"
              id="button-addon2"
              @click="buscarAddress"
            >
              Usar
            </button>
          </div>
          <p v-if="cepNotFound && zipcode" style="font-size: 12px" class="text-danger mt-1">
            CEP não encontrado no cadastro.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      cepNotFound: false,
      zipcode: null,
      showMini: (sessionStorage.getItem("hideMini") ? false : true),
      objZipCodeDefault: false
    };
  },
  mounted() {
    if (this.addressDefault) {
      this.objZipCodeDefault = this.addressDefault;
      this.zipcode = this.addressDefault.cep;
    }

    window.addEventListener("resize", this.updateMobileStatus);
    this.updateMobileStatus();
  },
  props: {
  smallIcon: {
    type: Boolean,
    default: false
  }
},
  watch: {
    user(value) {
      if (value) {
        this.$store.dispatch("address/get_address_default");
      }
    },

    addressDefault(newAddress) {
      if (newAddress) {
        this.objZipCodeDefault = newAddress;
        this.zipcode = newAddress.cep;
      }
    },
  },
  methods: {
    updateMobileStatus() {
      this.isMobile = window.innerWidth <= 768;
      if (this.isMobile) {
        this.showMini = false; // Se for mobile, set showMini para false
      }
    },
    closeMini(){
      sessionStorage.setItem("hideMini", true)
      this.showMini = false
    },
    buscarAddress() {
      axios
        .get(`https://viacep.com.br/ws/${this.zipcode}/json/`)
        .then((response) => {
          if (response.data.cep == undefined) {
            this.cepNotFound = true;
            return;
          } else {
            this.cepNotFound = false;
          }
          sessionStorage.setItem(
            "zipcodedefault",
            JSON.stringify(response.data)
          );
          this.objZipCodeDefault = true
          this.$refs.Close.click();
          //location.reload();
        })
        .catch((error) => {
          console.error("Erro ao obter o endereço:", error);
          throw error;
        });
    },
  },
  computed: {
    selectedZipcode() {
      if (sessionStorage.getItem("zipcodedefault")) {
        this.objZipCodeDefault = JSON.parse(sessionStorage.getItem("zipcodedefault"));
        this.zipcode = this.objZipCodeDefault?.cep; // Retorna o objeto completo do CEP
      } else {
        this.objZipCodeDefault = false;
      }
      return this.objZipCodeDefault;
    },
    addressDefault() {
      return this.$store.state.address.addressDefault;
    },
    user() {
      return this.$store.state.user.current_user;
    },
  },
  beforeCreate() {
    //this.$store.dispatch("address/get_address_default");
  },
  beforeDestroy() {
    // Remove o ouvinte de redimensionamento ao destruir o componente
    window.removeEventListener("resize", this.updateMobileStatus);
  },
};
</script>

<style scoped>
.zipcode-known-small {
  width: 14px !important;
  margin-left: 0 !important;
}

.zipcode-unknown-small {
  width: 14px !important;
  margin-left: 0 !important;
}

.zipcode-white {
  color: white !important;
  font-size: 0.8rem !important;
  font-weight: 400 !important;
}

.cursor-pointer{
  cursor: pointer;
  white-space: nowrap;
  font-size: 0.9rem;
  color: rgb(46, 103, 174); 
  margin-left: 0rem;
}
.zipcard {
  position: absolute;
  width: 300px;
  z-index: 2;
  margin-top: 1.3rem;
}
.card-title {
  font-weight: bold;
}
.zipcard::before {
  width: 1em;
  height: 1em;
  content: "";
  position: absolute;
  background: #fff;
  left: 20%;
  margin-left: -0.5em;
  border-bottom: solid 1px rgba(0, 0, 0, 0.1);
  border-right: solid 1px rgba(0, 0, 0, 0.1);
  box-shadow: 4px 0 4px -4px rgba(0, 0, 0, 0.15),
    1px 1px 1px -1px rgba(0, 0, 0, 0.2);

  top: -0.5625em;
  bottom: auto;
  transform: rotate(225deg);
}
.zipcode-known{
  width: 12%;
  margin-left: -35%;
}
.zipcode-unknown {
  width: 12%;
}
.selectedZipcode {
  margin-right: 3.7rem;
}
.modal-dialog.modal-dialog-centered {
  min-width: 600px;
}
.modal-content {
  border-radius: 0.5rem;
}
.modal-header {
  border-bottom: 0px;
}
@media (min-width: 360px) and (max-width: 768px) {
  .cursor-pointer{
    margin-left: 0rem;
    font-size: 10px;
  }
  .selectedZipcode {
    margin-right: 0rem;
  }
  .zipcode-known{
    width: 12%;
    margin-left: -0%;
  }
  .zipcode-unknown {
    width: 12%;
    margin-left: 0%;
  }
}
/* .zipcard::before { balao seta para baixo
    width: 1em;
    height: 1em;
    content: "";
    position: absolute;
    transform: rotate(45deg);
    background: #fff;
    left: 50%;
    margin-left: -0.5em;
    border-bottom: solid 1px rgba(0, 0, 0, 0.1);
    border-right: solid 1px rgba(0, 0, 0, 0.1);
    box-shadow: 4px 0 4px -4px rgba(0, 0, 0, 0.15), 1px 1px 1px -1px rgba(0, 0, 0, 0.2);
    bottom: -0.5625em;
} */
</style>
